import IconCodeBlock from '@apollo/icons/default/IconCodeBlock.svg';
import IconOutlink from '@apollo/icons/default/IconOutlink.svg';
import IconWorkflow from '@apollo/icons/default/IconWorkflow.svg';
import { IconButton } from '@apollo/orbit';
import classnames from 'classnames';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

type QueryPlanActionsProps = {
  mermaidView: boolean;
  setMermaidView: React.Dispatch<React.SetStateAction<boolean>>;
  queryPlanSVGText?: string;
};

export const QueryPlanActions = (props: QueryPlanActionsProps) => {
  const { mermaidView, setMermaidView, queryPlanSVGText } = props;

  return (
    <>
      <Tooltip label="Show plan as chart">
        <IconButton
          variant="hidden"
          aria-label="Show plan as chart"
          data-testid="mermaid-plan-button"
          className={classnames(
            mermaidView && 'bg-secondary text-link hover:bg-secondary',
          )}
          type="button"
          size="sm"
          icon={<IconWorkflow />}
          onClick={() => setMermaidView(true)}
        />
      </Tooltip>
      <Tooltip label="Show plan as text">
        <IconButton
          variant="hidden"
          aria-label="Show plan as text"
          data-testid="text-plan-button"
          className={classnames(
            !mermaidView && 'bg-secondary text-link hover:text-secondary',
          )}
          type="button"
          size="sm"
          icon={<IconCodeBlock />}
          onClick={() => setMermaidView(false)}
        />
      </Tooltip>
      <Tooltip label="Open query plan in a new window">
        <IconButton
          variant="hidden"
          aria-label="Open query plan in a new window"
          isDisabled={!queryPlanSVGText}
          size="sm"
          type="button"
          onClick={() => {
            if (queryPlanSVGText)
              window.open(
                URL.createObjectURL(
                  new Blob([queryPlanSVGText], {
                    type: 'image/svg+xml',
                  }),
                ),
              );
          }}
          icon={<IconOutlink />}
        />
      </Tooltip>
    </>
  );
};
